//create an axios instance

import axios from 'axios';
import { envs } from './constants';

const axiosInstance = axios.create({
  baseURL: envs.API_URL,
});

export default axiosInstance;
